import {
  AI_RELAY_ROUTES,
  AIRelayResponseSchema,
  AIRelayStatusSchema,
  type AIRelayRequest,
  type AIRelayResponse,
  type AIRelayStatus,
} from '@aibi/ai-core';
import type { AppError, Result } from '@aibi/shared';
import { postJson, requestJson, type FetchFn } from '../../api/http-client';

/**
 * Cliente del relay de IA del servidor. El navegador solo conoce rutas relativas de la
 * propia API: la URL del proveedor (n8n) y sus credenciales viven en el servidor.
 */
export interface AIRelayApi {
  status(signal?: AbortSignal): Promise<Result<AIRelayStatus, AppError>>;
  generate(body: AIRelayRequest, signal?: AbortSignal): Promise<Result<AIRelayResponse, AppError>>;
}

export interface AIRelayApiOptions {
  readonly baseUrl: string;
  readonly fetch: FetchFn;
}

/**
 * @example
 * const api = createAIRelayApi({ baseUrl: '', fetch: window.fetch.bind(window) });
 * const status = await api.status();
 */
export function createAIRelayApi({ baseUrl, fetch }: AIRelayApiOptions): AIRelayApi {
  return {
    status: (signal) =>
      requestJson(
        fetch,
        `${baseUrl}${AI_RELAY_ROUTES.status}`,
        AIRelayStatusSchema,
        signal ? { signal } : {},
      ),
    generate: (body, signal) =>
      postJson(
        fetch,
        `${baseUrl}${AI_RELAY_ROUTES.generate}`,
        body,
        AIRelayResponseSchema,
        signal ? { signal } : {},
      ),
  };
}
